import { create } from 'zustand';

export interface DocumentSectionProposal {
  id: string;
  documentCode: string;
  sectionCode: string;
  text: string;
  title?: string;
}

interface DocumentProposalState {
  mountedDocumentCode: string | null;
  pending: DocumentSectionProposal | null;
  setMountedDocumentCode: (code: string | null) => void;
  deliver: (proposal: DocumentSectionProposal) => void;
  consume: (id: string) => void;
}

export const useDocumentProposalStore = create<DocumentProposalState>((set) => ({
  mountedDocumentCode: null,
  pending: null,
  setMountedDocumentCode: (code) => set({ mountedDocumentCode: code }),
  deliver: (proposal) => set({ pending: proposal }),
  consume: (id) => set((state) => (state.pending?.id === id ? { pending: null } : state)),
}));
